var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pre',{staticClass:"fasta-sequence"},[_vm._v(_vm._s(_vm.fastaString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }